// extracted by mini-css-extract-plugin
module.exports = {"fill-politico-red":"_2SNHEWcf_annHCP1H3qGiV","styles":"_1xl1SU2iSli2GHAKcL7Nxu"};